import { render } from "./HourOfAI.vue?vue&type=template&id=64433d18"
import script from "./HourOfAI.vue?vue&type=script&lang=js"
export * from "./HourOfAI.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__